import * as Actions from '../../actions/report';


const initialState={
    data: [],
    isLoading: false,
    isLoaded : false,
    error: false
};

const report = function (state = initialState, action) {
    switch (action.type) {
      
            
        case Actions.GET_DAILY_REPORT: case Actions.GET_DAYOFWEEK_REPORT : case Actions.GET_PRODUCTSALES_REPORT :{
            return {
                ...state,
                isLoading: true,
                isLoaded : false,
                error: false
            };
        }
        case Actions.GET_DAILY_REPORT_SUCCESS:  case Actions.GET_DAYOFWEEK_REPORT_SUCCESS: case Actions.GET_PRODUCTSALES_REPORT_SUCCESS : {

            return {
                ...state,
                data: action.payload,
                isLoading: false,
                isLoaded : true,
                error: false
            };
        }
        case Actions.GET_DAILY_REPORT_ERROR: case Actions.GET_DAYOFWEEK_REPORT_ERROR: case Actions.GET_PRODUCTSALES_REPORT_ERROR : {
            return {
                ...state,
                isLoading: false,
                isLoaded : false,
                error: action.error
            };
        }
            

        default: {
            return state;
        }
    }
};

export default report